import React from "react";
import { useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = ({ toggleSidebar, isCollapsed, setIsCollapsed }) => {
    const location = useLocation();

    // Simple breadcrumb/title logic based on current path
    const getPageTitle = () => {
        const path = location.pathname;
        if (path === "/dashboard" || path.includes("/home")) return "Panel Principal";
        if (path.includes("/athletes")) return "Gestión de Atletas";
        if (path.includes("/training")) return "Entrenamientos";
        if (path.includes("/accounting")) return "Contabilidad";
        if (path.includes("/memberships")) return "Membresías";
        if (path.includes("/notifications")) return "Notificaciones";
        if (path.includes("/graphics")) return "Gráficas";
        if (path.includes("/mob")) return "Panel Administrativo";
        return "Elevva Intelligence";
    };

    const firstName = localStorage.getItem("first_name") || "Admin";
    const lastName = localStorage.getItem("last_name") || "";
    const profilePic = localStorage.getItem("profile_pic");
    const userRole = localStorage.getItem("elevva_role");

    // Role mapping
    const getRoleName = () => {
        if (userRole === "10") return "Administrador";
        if (userRole === "20") return "Entrenador";
        return "Usuario";
    };

    return (
        <header className="dashboard-navbar">
            <div className="navbar-left">
                <button className="navbar-toggle-btn d-lg-none" onClick={toggleSidebar}>
                    <i className="bi bi-list"></i>
                </button>
                <button
                    className="navbar-collapse-toggle d-none d-lg-flex"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    title={isCollapsed ? "Expandir menú" : "Contraer menú"}
                >
                    <i className={`bi bi-chevron-${isCollapsed ? "right" : "left"}`}></i>
                </button>
                <div className="navbar-title-container">
                    <span className="navbar-subtitle">ELEVVA CORP</span>
                    <h1 className="navbar-title">
                        {getPageTitle()}
                        {location.pathname.includes("/accounting") && <span className="pro-badge ms-2">PLUS</span>}
                    </h1>
                </div>
            </div>

            <div className="navbar-right">
                {/* <div className="navbar-search d-none d-md-flex">
                    <i className="bi bi-search"></i>
                    <input type="text" placeholder="Buscar..." className="navbar-search-input" />
                </div> */}

                <div className="navbar-user-profile">
                    <div className="user-info d-none d-sm-block">
                        <span className="user-name">{firstName} {lastName}</span>
                        <span className="user-role">{getRoleName()}</span>
                    </div>
                    <div className="user-avatar">
                        <span>{firstName.charAt(0)}{lastName.charAt(0)}</span>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
